module.exports = require("./lib/validator.js");